
import React from 'react'
import './index.less'


export class AppGridBar extends React.Component{

    static Left: React.FC<{children?:any}> = props =>{
        return (<div className='app-grid-bar-left-outer'>
        <div className='app-grid-bar-left-inner'>
            {props.children}
        </div>
    </div>)
    }

    static Right : React.FC<{children?:any}> = props =>{
        return (<div className='app-grid-bar-right-outer'>
        <div className='app-grid-bar-right-inner'> 
            {props.children}
        </div></div>)
    }

    render () {
        return <div className='app-grid-bar-container'>{this.props.children}</div>
    }
}


// WEBPACK FOOTER //
// ./src/qcc/AppGridBar/index.tsx